import { Base, Component, Inject } from '@/vue-property-decorator'
import { GameCardCommonProps } from '../../common.type'
import style from './style.module.scss'

/**
 * 推荐角标
 */
@Component<LabelGameStatus>({
  name: 'LabelGameStatus'
})
export default class LabelGameStatus extends Base {
  /** 接收根级传入的Props */
  @Inject() cardProps!: Required<GameCardCommonProps>

  render() {
    const { inCardShape } = this.cardProps
    return (
      <my-img
        class={{
          'label-game-status': true,
          [style['label-game-status']]: true,
          [`type-${inCardShape}-default`]: true,
          [style[`type-${inCardShape}-default`]]: true
        }}
        src={'/lobby_asset/common/common/home/img_game_tj_1.png'}
      />
    )
  }
}
